export default __webpack_public_path__ + "static/media/ic_chevron_up_primary.846521ff.svg";